module.exports = __webpack_public_path__ + "static/media/level-icon.1b7dc3b0.png";